import BaseModel from './BaseModel';

/** Class representing accounting statistics. */
class AccountingStat extends BaseModel {}

export default AccountingStat;